import { render } from "./SwiperCarousel.vue?vue&type=template&id=966ec462&scoped=true"
import script from "./SwiperCarousel.vue?vue&type=script&lang=js"
export * from "./SwiperCarousel.vue?vue&type=script&lang=js"

import "./SwiperCarousel.vue?vue&type=style&index=0&id=966ec462&scoped=true&lang=scss"
import "./SwiperCarousel.vue?vue&type=style&index=1&id=966ec462&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966ec462"]])

export default __exports__